import React from "react";

/**
 * Toggle chips for a library list's filters (Forms, Swipe Decks).
 *
 * Each group is mutually exclusive and clears back to "all" when you click the
 * chip that's already on, so a group costs two chips instead of three: an
 * "All …" chip only ever undoes a choice, and three of them in a row read as
 * filters while doing nothing. Groups are separated by a hairline so the row
 * still parses as N controls rather than one long strip of buttons.
 *
 * Each group: { key, value, onChange, options: [{ value, label }] }.
 * `value` is the owning list's filter state, where "all" means unfiltered.
 */
function LibraryFilterChips({ groups }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {groups.map((group, i) => (
        <React.Fragment key={group.key}>
          {i > 0 && (
            <span aria-hidden className="mx-1 h-5 w-px shrink-0 bg-slate-200" />
          )}
          {group.options.map((option) => {
            const isOn = group.value === option.value;
            return (
              <button
                key={option.value}
                type="button"
                aria-pressed={isOn}
                onClick={() => group.onChange(isOn ? "all" : option.value)}
                className={`rounded-lg border px-3 py-1.5 text-xs font-semibold transition-colors ${
                  isOn
                    ? "border-violet-700 bg-violet-700 text-white"
                    : "border-slate-200 text-slate-600 hover:bg-slate-50"
                }`}
              >
                {option.label}
              </button>
            );
          })}
        </React.Fragment>
      ))}
    </div>
  );
}

export default LibraryFilterChips;
